//removeIf(production)
import ClaroluzEventDispatch from "../../../../../infra/services/claroluz-event-dispatch";
import translation from "../../../../../../lang/es.json";
import ClaroluzEvents from '../../../../../infra/critical/claroluz-events';
import ClaroluzDropzone from '../../../../../infra/services/claroluz-dropzone';
import ClaroluzValidateEvent from '../../shared/validate-event/validate-event';
//endRemoveIf(production)

class ClaroluzDropzonePdf {
    private dropzone: any;

    constructor() {        
        const options = {
            maxFilesize: 10,
            maxFiles: 5,
            addRemoveLinks: true,
            uploadMultiple: true,
            acceptedFiles: 'image/*,application/pdf',
            autoProcessQueue: false,
            dictFileTooBig: translation.uploader.pdf.dropzone.fileTooBig,
            dictInvalidFileType: translation.uploader.pdf.dropzone.invalidFileType,
            dictMaxFilesExceeded: translation.uploader.pdf.dropzone.maxFilesExceeded,
            clickable: '.claroluz-dropzone-clickable'
        };
        
        this.dropzone = new ClaroluzDropzone('.claroluz-uploader-pdf', 'claroluz-preview-template', options).dropzone;
        this.addedFileEvent();
        this.removedFileEvent();
        this.submit();
    }

    private addedFileEvent() {
        this.dropzone.on('addedfile', (file: any) => {
            new ClaroluzEvents(appProperties(), 'uploader', 'dropzone', 'added-file');

            if (!document.querySelector('.claroluz-uploader')?.classList.contains('type-pdf')) {
                document.querySelector('.claroluz-uploader')?.classList.remove('type-cups');
                document.querySelector('.claroluz-uploader')?.classList.add('type-pdf');
            }

            new ClaroluzValidateEvent();
        });
    }

    private removedFileEvent() {
        this.dropzone.on('removedfile', (file: any) => {
            new ClaroluzEvents(appProperties(), 'uploader', 'dropzone', 'removed-file');
            new ClaroluzValidateEvent();
        });
    }

    private submit() {
        document.addEventListener('claroluz_send_pdf', async () => {
            const file = this.dropzone.getAcceptedFiles();
            const encodedFile = await this.parseFiles(file);

            new ClaroluzEventDispatch('claroluz_submit', {type: 'pdf', data: encodedFile});  
        });
    }

    private async toBase64(file: any) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                let encoded = reader.result ? reader.result.toString().replace(/^data:(.*,)?/, '') : null;
                if (encoded != null && (encoded.length % 4) > 0) {
                    encoded += '='.repeat(4 - (encoded.length % 4));
                } else if (encoded === null) {
                    reject('Error al leer el archivo');
                }

                resolve(encoded);
            }
            reader.onerror = error => reject(error);
        });
    }

    private async parseFiles(file: any) {
        let base64Files = [];
    
        for (let i = 0; i < file.length; i++) {
            let base = await this.toBase64(file[i]);
            base64Files.push(base);
        }
    
        return base64Files;
    }
}

//removeIf(production)
export default ClaroluzDropzonePdf;

function appProperties(): import("../../../../../infra/critical/claroluz-events-properties").default {
    throw new Error('Function not implemented.');
}
//endRemoveIf(production)